import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('navigation', {
  state: () => ({
    section: 'messages'
  }),
  actions: {
    showMessages() {
      this.section = 'messages';
    },
    showContacts() {
      this.section = 'contacts';
    },
    showFavorites() {
      this.section = 'favorites';
    }
  }
});
